import { z } from 'zod';

export const RiskExistingControlsSchema = z.object({
    id: z.union([z.string(), z.number()]).optional(),
    _id: z.string().optional(),
    name: z.string().min(1, "form.validation.controlNameRequired"),
    description: z.string().optional(),
    owner: z.string().min(1, "form.validation.ownerRequired"),
    effectiveness: z.string().min(1, "form.validation.effectivenessRequired"),
    controlType: z.string().min(1, "form.validation.controlTypeRequired"),
    createdAt: z.union([z.date(), z.string()]).optional(),
    updatedAt: z.union([z.date(), z.string()]).optional(),
});

export const CreateRiskExistingControlsSchema = RiskExistingControlsSchema.omit({ id: true, _id: true, createdAt: true, updatedAt: true });
export const UpdateRiskExistingControlsSchema = RiskExistingControlsSchema.partial();

// Frontend Form Schema
export const RiskExistingControlsFormSchema = z.object({
    name: z.string().min(1, "form.validation.controlNameRequired"),
    description: z.string().optional(),
    owner: z.string().min(1, "form.validation.ownerRequired"),
    effectiveness: z.string().min(1, "form.validation.effectivenessRequired"),
    controlType: z.string().min(1, "form.validation.controlTypeRequired"),
});
